if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.setupBoeRafflePhoneRequirement();
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        const boeRaffleQuantityInput = this.form.querySelector('[data-boe-raffle-variant-id]');
        const boeAttendeeQuantityInput = this.form.querySelector('[data-boe-attendee-quantity]');
        const raffleQuantity = boeRaffleQuantityInput
          ? Math.max(0, parseInt(boeRaffleQuantityInput.value || '0', 10) || 0)
          : 0;
        const attendeeQuantity = boeAttendeeQuantityInput
          ? Math.max(0, parseInt(boeAttendeeQuantityInput.value || '0', 10) || 0)
          : 1;
        if (boeRaffleQuantityInput) boeRaffleQuantityInput.value = String(raffleQuantity);
        if (boeAttendeeQuantityInput) boeAttendeeQuantityInput.value = String(attendeeQuantity);
        const boeRafflePhoneInput = this.form.querySelector('[data-boe-raffle-phone]');
        const boeRaffleVehicleInput = this.form.querySelector('[data-boe-raffle-vehicle]');
        const requiresRafflePhone = Boolean(
          boeRafflePhoneInput &&
            (boeRafflePhoneInput.dataset.boeRequireRafflePhone === 'true' || raffleQuantity > 0)
        );

        if (requiresRafflePhone && !this.hasUsablePhoneNumber(boeRafflePhoneInput.value)) {
          this.handleErrorMessage('Please enter a phone number so BOE can contact raffle winners.');
          this.error = true;
          boeRafflePhoneInput.focus();
          return;
        }
        const requiresRaffleVehicle = Boolean(
          boeRaffleVehicleInput &&
            (boeRaffleVehicleInput.dataset.boeRequireRaffleVehicle === 'true' || raffleQuantity > 0)
        );
        if (requiresRaffleVehicle && !boeRaffleVehicleInput.value.trim()) {
          this.handleErrorMessage('Please enter your vehicle type for raffle prize eligibility.');
          this.error = true;
          boeRaffleVehicleInput.focus();
          return;
        }
        this.error = false;

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (boeRaffleQuantityInput) {
          const attendeeVariantId = Number(
            this.form.querySelector('[data-boe-attendee-variant-id]')?.dataset.boeAttendeeVariantId || this.variantIdInput.value
          );
          const rafflePhone = boeRafflePhoneInput?.value?.trim() || '';
          const raffleVehicleType = boeRaffleVehicleInput?.value?.trim() || '';
          const payload = { items: [] };

          if (attendeeQuantity > 0) {
            // BOE_DOOR_PRICE_2026: visible in cart, checkout, and Shopify notifications.
            payload.items.push({
              id: attendeeVariantId,
              quantity: attendeeQuantity,
              properties: { 'At-door ticket price': '$5 (online price: $3)' },
            });
          }

          if (raffleQuantity > 0) {
            payload.items.push({
              id: Number(boeRaffleQuantityInput.dataset.boeRaffleVariantId),
              quantity: raffleQuantity,
              properties: {
                'Winner contact phone': rafflePhone,
                'Vehicle type': raffleVehicleType,
              },
            });
          }

          if (payload.items.length === 0) {
            this.handleErrorMessage('Choose at least one attendee ticket or raffle ticket.');
            this.error = true;
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            return;
          }

          if (this.cart) {
            payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
            payload.sections_url = window.location.pathname;
            this.cart.setActiveElement(document.activeElement);
          }

          config.headers['Content-Type'] = 'application/json';
          config.body = JSON.stringify(payload);
        } else {
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      setupBoeRafflePhoneRequirement() {
        const phoneInput = this.form.querySelector('[data-boe-raffle-phone]');
        const vehicleInput = this.form.querySelector('[data-boe-raffle-vehicle]');
        const raffleQuantityInput = this.form.querySelector('[data-boe-raffle-variant-id]');
        const contactWrapper = this.form.querySelector('[data-boe-raffle-contact]');
        if (!phoneInput || !vehicleInput || !raffleQuantityInput || !contactWrapper) return;

        const syncRequirement = () => {
          const raffleQuantity = Math.max(0, parseInt(raffleQuantityInput.value || '0', 10) || 0);
          const required = raffleQuantity > 0;
          contactWrapper.hidden = !required;
          phoneInput.required = required;
          phoneInput.dataset.boeRequireRafflePhone = required ? 'true' : 'false';
          vehicleInput.required = required;
          vehicleInput.dataset.boeRequireRaffleVehicle = required ? 'true' : 'false';
          if (!required) {
            phoneInput.value = '';
            vehicleInput.value = '';
            this.handleErrorMessage();
          }
        };

        raffleQuantityInput.addEventListener('input', syncRequirement);
        raffleQuantityInput.addEventListener('change', syncRequirement);
        contactWrapper.closest('[data-boe-raffle-addon]')?.addEventListener('click', () => {
          window.setTimeout(syncRequirement, 0);
        });
        syncRequirement();
      }

      hasUsablePhoneNumber(value) {
        return String(value || '').replace(/\D/g, '').length >= 7;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
